import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';

const WhoWeAre = () => {
  return (
    <Box
      sx={{ 
        p: { xs: 2, md: 4 }, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center' 
      }}
    >
      {/* Título */}
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{
          color: 'rgb(3,116,206)',
          fontWeight: 'bold',
          fontSize: { xs: '2rem', md: '3rem' }
        }}
      >
        Who We Are
      </Typography>
      {/* Texto descriptivo */}
      <Typography
        variant="h6"
        align="center"
        mb={4}
        sx={{
          width: { xs: '90%', md: '75%' },
          fontSize: { xs: '1rem', md: '1.25rem' }
        }}
      >
        We are a team of professionals with over 30 years of experience in components and integration. We specialize in proactive business development and provide support to manufacturers in Western Europe in the following areas:
      </Typography>
      {/* Grid de 4 cuadrados */}
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            elevation={3}
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              height: { xs: '13rem', md: '15rem' },
              backgroundColor: 'rgb(139,206,252, 0.45)',
              borderRadius: '1rem'
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/Sales.png`}
              alt="Ventas"
              style={{ width: '5rem', height: '5rem', marginBottom: '1rem' }}
            />
            <Typography variant="h5" sx={{ color: 'rgb(3,116,206)', fontWeight: 'bold' }}>
              Sales
            </Typography>
            <Typography variant="h6" sx={{ marginTop: '0.5rem' }}>
              Commercial strategy and key account management.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            elevation={3}
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              height: { xs: '13rem', md: '15rem' },
              backgroundColor: 'rgb(139,206,252, 0.45)',
              borderRadius: '1rem'
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/Marketing.png`}
              alt="Marketing"
              style={{ width: '5rem', height: '5rem', marginBottom: '1rem' }}
            />
            <Typography variant="h5" sx={{ color: 'rgb(3,116,206)', fontWeight: 'bold' }}>
              Marketing
            </Typography>
            <Typography variant="h6" sx={{ marginTop: '0.5rem' }}>
              Development of campaigns to strengthen the brand.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            elevation={3}
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              height: { xs: '13rem', md: '15rem' },
              backgroundColor: 'rgb(139,206,252, 0.45)',
              borderRadius: '1rem'
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/Logistics.png`}
              alt="Logistics"
              style={{ width: '5rem', height: '5rem', marginBottom: '1rem' }}
            />
            <Typography variant="h5" sx={{ color: 'rgb(3,116,206)', fontWeight: 'bold' }}>
              Logistics
            </Typography>
            <Typography variant="h6" sx={{ marginTop: '0.5rem' }}>
              Optimization and expansion of distribution in Europe.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            elevation={3}
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              height: { xs: '13rem', md: '15rem' },
              backgroundColor: 'rgb(139,206,252, 0.45)',
              borderRadius: '1rem'
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/Legal_advisory.png`}
              alt="Legal advisory"
              style={{ width: '5rem', height: '5rem', marginBottom: '1rem' }}
            />
            <Typography variant="h5" sx={{ color: 'rgb(3,116,206)', fontWeight: 'bold' }}>
              Legal advisory
            </Typography>
            <Typography variant="h6" sx={{ marginTop: '0.5rem' }}>
              Regulatory compliance and commercial protection.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default WhoWeAre;
